<template>
    <v-container>
      <v-card>
        <v-tabs>
          <v-tab v-model="activeTab">子代理升级规则</v-tab>
          <v-spacer></v-spacer>
          <v-tab v-if="canAddLevel" @click="showAddDialog = true">
            <v-btn icon color="primary">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-tab>
        </v-tabs>
        <v-card-title>子代理升级规则</v-card-title>
        <v-data-table :headers="headers" :items="upgradeRules" class="elevation-1">
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small @click="editLevel(item)">mdi-pencil</v-icon>
            <v-icon small @click="deleteLevel(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
  
        <!-- 编辑代理级别对话框 -->
        <v-dialog v-model="showEditDialog" max-width="500px" @click:outside="closeEditDialog">
          <v-card>
            <v-card-title>编辑代理级别</v-card-title>
            <v-card-text>
              <v-text-field label="代理等级" v-model="currentLevel.level" readonly></v-text-field>
              <v-text-field label="销售数量" v-model="currentLevel.sales" type="number" min="0"></v-text-field>
              <v-text-field label="佣金比例" v-model="currentLevel.commission" type="number" min="0"></v-text-field>
              <v-text-field label="可创建子代理数量" v-model="currentLevel.subAgentLimit" type="number" min="0"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="saveLevel">保存</v-btn>
              <v-btn @click="closeEditDialog">取消</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
  
        <!-- 新增代理级别对话框 -->
        <v-dialog v-model="showAddDialog" max-width="500px" @click:outside="closeAddDialog">
          <v-card>
            <v-card-title>新增代理级别</v-card-title>
            <v-card-text>
              <v-text-field label="代理等级" v-model="newLevel.level" readonly></v-text-field>
              <v-text-field label="销售数量" v-model="newLevel.sales" type="number" min="0"></v-text-field>
              <v-text-field label="佣金比例" v-model="newLevel.commission" type="number" min="0"></v-text-field>
              <v-text-field label="可创建子代理数量" v-model="newLevel.subAgentLimit" type="number" min="0"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="addLevel">确认</v-btn>
              <v-btn @click="closeAddDialog">取消</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-container>
  </template>
  
  <script>
  export default {
    name: 'SubAgentUpgradeRules',
    data() {
      return {
        activeTab: 0,
        headers: [
          { title: '代理等级', value: 'level' },
          { title: '销售数量', value: 'sales' },
          { title: '佣金比例', value: 'commission' },
          { title: '可创建子代理数量', value: 'subAgentLimit' },
          { title: '操作', value: 'actions', sortable: false },
        ],
        upgradeRules: [
          { level: '一级', sales: 100, commission: 10, subAgentLimit: 5 },
          { level: '二级', sales: 200, commission: 15, subAgentLimit: 10 },
        ],
        userPermissions: ['view', 'add'], // 示例权限
        showEditDialog: false,
        showAddDialog: false,
        currentLevel: {
          level: '',
          sales: 0,
          commission: 0,
          subAgentLimit: 0,
        },
        newLevel: {
          level: '',
          sales: 0,
          commission: 0,
          subAgentLimit: 0,
        },
      };
    },
    computed: {
      canAddLevel() {
        return this.userPermissions.includes('add');
      },
    },
    methods: {
      editLevel(item) {
        this.currentLevel = { ...item };
        this.showEditDialog = true;
      },
      saveLevel() {
        const index = this.upgradeRules.findIndex(rule => rule.level === this.currentLevel.level);
        if (index !== -1) {
          this.upgradeRules.splice(index, 1, { ...this.currentLevel });
        }
        this.closeEditDialog();
      },
      deleteLevel(item) {
        const index = this.upgradeRules.findIndex(rule => rule.level === item.level);
        if (index !== -1) {
          this.upgradeRules.splice(index, 1);
        }
      },
      addLevel() {
        const newLevelNumber = this.upgradeRules.length + 1;
        this.newLevel.level = `${newLevelNumber}级`;
        this.upgradeRules.push({ ...this.newLevel });
        this.closeAddDialog();
      },
      closeEditDialog() {
        this.showEditDialog = false;
        this.currentLevel = {
          level: '',
          sales: 0,
          commission: 0,
          subAgentLimit: 0,
        };
      },
      closeAddDialog() {
        this.showAddDialog = false;
        this.newLevel = {
          level: '',
          sales: 0,
          commission: 0,
          subAgentLimit: 0,
        };
      },
    },
  };
  </script>
  
  <style>
  /* 根据需要添加样式 */
  </style>